import { useEffect } from 'react';
import { isClient } from '@tcp/core/src/utils';
import ResizeObserver from 'resize-observer-polyfill';
/**
 * Resize observer which observes the given element ref for resize change
 * and calls the callback function if there is any change
 *
 * @param {object} containerRef
 * @param {function} callbackFn
 */
const useResizeObserver = (containerRef, callbackFn) => {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isClient()) {
      const observer = new ResizeObserver(callbackFn);
      if (containerRef.current) observer.observe(containerRef.current);
      return () => {
        if (containerRef.current) observer.disconnect();
      };
    }
  }, [containerRef]);

  return [];
};

export default useResizeObserver;
